import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const TabNavigation = ({ className = '' }) => {
  const location = useLocation();

  const navigationItems = [
    {
      label: 'Today',
      path: '/today',
      icon: 'Calendar',
      tooltip: 'Daily goals and reading'
    },
    {
      label: 'Stats',
      path: '/stats',
      icon: 'BarChart3',
      tooltip: 'Progress analytics'
    },
    {
      label: 'History',
      path: '/history',
      icon: 'Clock',
      tooltip: 'Historical review'
    }
  ];

  const isActive = (path) => location?.pathname === path;

  return (
    <>
      {/* Mobile Bottom Navigation */}
      <nav className={`lg:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-border z-100 ${className}`}>
        <div className="flex items-center justify-around px-4 py-2">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`flex flex-col items-center justify-center min-h-touch px-3 py-2 rounded-lg transition-all duration-200 animate-spring ${
                isActive(item?.path)
                  ? 'text-primary bg-primary/10' :'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
              title={item?.tooltip}
            >
              <Icon 
                name={item?.icon} 
                size={20} 
                className={`mb-1 transition-colors duration-200 ${
                  isActive(item?.path) ? 'text-primary' : 'text-current'
                }`}
              />
              <span className={`text-xs font-caption font-medium transition-colors duration-200 ${
                isActive(item?.path) ? 'text-primary' : 'text-current'
              }`}>
                {item?.label}
              </span>
            </Link>
          ))}
        </div>
      </nav>
      {/* Desktop Header Navigation */}
      <nav className={`hidden lg:flex items-center space-x-1 ${className}`}>
        {navigationItems?.map((item) => (
          <Link
            key={item?.path}
            to={item?.path}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 animate-spring ${
              isActive(item?.path)
                ? 'text-primary bg-primary/10 shadow-gentle'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted hover:shadow-gentle-hover'
            }`}
            title={item?.tooltip}
          >
            <Icon 
              name={item?.icon} 
              size={18} 
              className={`transition-colors duration-200 ${
                isActive(item?.path) ? 'text-primary' : 'text-current'
              }`}
            />
            <span className={`font-caption font-medium transition-colors duration-200 ${
              isActive(item?.path) ? 'text-primary' : 'text-current'
            }`}>
              {item?.label}
            </span>
          </Link>
        ))}
      </nav>
    </>
  );
};

export default TabNavigation;